module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANhJREFUeNqc0j8LQWEUx/F7/YlIlBjErKxegIFIBgab2WpWMmJgYDPIK5CXoJQycm0WCwMyUFYeXzw3UvLn1Oc+de/vdJ5OVxVCKL+WQfmjTD/mIzB/2xRDHEt4Pl0vgS5CaMlzo75ZRAoFjLCAhiB6CLxOSstgDiVY4ccJHQyxUphkQQZTTBBFGDO0YcRY3Kt6uxmPJnbIw4ayDNSvATTEo1J6kwNOuKHJjzXZkMVZvlvDrjfpXDhiADN82D5N6evZ50XsUYQbXhyQRAVzuaBbqf/8excBBgBe+M9pFP55mwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/sent.png
// module id = 177
// module chunks = 462